import request from '@/utils/request'
import axios from 'axios'
import Cookies from 'js-cookie'

// ---- 后台管理 ----
export function orderFormList(params) {
  return request({ url: `/order_forms/`, method: 'get', params })
}
export function orderFormCreate(data) {
  return request({ url: `/order_forms/`, method: 'post', data })
}
export function orderFormUpdate(data) {
  return request({ url: `/order_forms/${data.id}/`, method: 'put', data })
}
export function orderFormDestroy(data) {
  return request({ url: `/order_forms/${data.id}/`, method: 'delete', data })
}
export function orderFormDetail(id) {
  return request({ url: `/order_forms/${id}/`, method: 'get' })
}

export function orderFormCategoryList(params) {
  return request({ url: `/order_form_categories/`, method: 'get', params })
}
export function orderFormCategoryCreate(data) {
  return request({ url: `/order_form_categories/`, method: 'post', data })
}
export function orderFormCategoryUpdate(data) {
  return request({ url: `/order_form_categories/${data.id}/`, method: 'put', data })
}
export function orderFormCategoryDestroy(data) {
  return request({ url: `/order_form_categories/${data.id}/`, method: 'delete', data })
}

export function orderFormBannerList(params) {
  return request({ url: `/order_form_banners/`, method: 'get', params })
}
export function orderFormBannerCreate(data) {
  return request({ url: `/order_form_banners/`, method: 'post', data })
}
export function orderFormBannerUpdate(data) {
  return request({ url: `/order_form_banners/${data.id}/`, method: 'put', data })
}
export function orderFormBannerDestroy(data) {
  return request({ url: `/order_form_banners/${data.id}/`, method: 'delete', data })
}

export function orderFormProductList(params) {
  return request({ url: `/order_form_products/`, method: 'get', params })
}
export function orderFormProductCreate(data) {
  return request({ url: `/order_form_products/`, method: 'post', data })
}
export function orderFormProductUpdate(data) {
  return request({ url: `/order_form_products/${data.id}/`, method: 'put', data })
}
export function orderFormProductDestroy(data) {
  return request({ url: `/order_form_products/${data.id}/`, method: 'delete', data })
}
export function orderFormProductDetail(id) {
  return request({ url: `/order_form_products/${id}/`, method: 'get' })
}

export function orderFormSubmissionList(params) {
  return request({ url: `/order_form_submissions/`, method: 'get', params })
}
export function orderFormSubmissionDetail(id) {
  return request({ url: `/order_form_submissions/${id}/`, method: 'get' })
}
export function orderFormSubmissionUpdate(data) {
  return request({ url: `/order_form_submissions/${data.id}/`, method: 'patch', data })
}

export function orderFormImportTemplate(id) {
  return axios({
    url: `/api/order_forms/${id}/import_template/`,
    headers: { Authorization: 'Bearer ' + Cookies.get('access') },
    responseType: 'blob',
    method: 'get',
  })
}

export function orderFormImportData(id, formData) {
  return axios({
    url: `/api/order_forms/${id}/import_data/`,
    headers: {
      Authorization: 'Bearer ' + Cookies.get('access'),
      'Content-Type': 'multipart/form-data',
    },
    method: 'post',
    data: formData,
  }).then((res) => {
    const body = res.data
    return body && body.data !== undefined ? body.data : body
  })
}

export function orderFormLinkGoods(id, data = { only_unlinked: true }) {
  return request({ url: `/order_forms/${id}/link_goods/`, method: 'post', data })
}

export function orderFormMpShare(id) {
  return request({ url: `/order_forms/${id}/mp_share/`, method: 'get' })
}

export function orderFormUpload(file) {
  const formData = new FormData()
  formData.append('file', file)
  return axios({
    url: '/api/order_form_upload/',
    headers: {
      Authorization: 'Bearer ' + Cookies.get('access'),
      'Content-Type': 'multipart/form-data',
    },
    method: 'post',
    data: formData,
  }).then((res) => {
    const body = res.data
    return body && body.data !== undefined ? body.data : body
  })
}

// ---- 公开页（免登录）----
export function publicOrderForm(slug) {
  return axios({
    url: `/api/public/order_forms/${encodeURIComponent(slug)}/`,
    method: 'get',
  }).then((res) => {
    const body = res.data
    return body && body.data !== undefined ? body.data : body
  })
}

export function publicOrderFormSubmit(slug, data) {
  return axios({
    url: `/api/public/order_forms/${encodeURIComponent(slug)}/submit/`,
    method: 'post',
    data,
  }).then((res) => {
    const body = res.data
    return body && body.data !== undefined ? body.data : body
  })
}
